module.exports = __webpack_public_path__ + "img/dots-project.a604648.svg";